var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Menu'),_c('Header',{attrs:{"title":"Profile"}}),_c('div',{staticClass:"profile_wrapper"},[_c('ProfileItem'),_c('div',{staticClass:"content_wrapper"},[_c('div',[_c('Experience'),_c('Education')],1),_c('div',[_c('Skill'),_c('FieldsOfStudy'),_c('Certification')],1)])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }